import { render, staticRenderFns } from "./RestPage.vue?vue&type=template&id=20447e59&scoped=true&"
import script from "./RestPage.vue?vue&type=script&lang=js&"
export * from "./RestPage.vue?vue&type=script&lang=js&"
import style0 from "./RestPage.vue?vue&type=style&index=0&id=20447e59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20447e59",
  null
  
)

export default component.exports